import React from 'react';
import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

const SpaceIcon = fn(__filename, styled.i`
  align-self: center;
  background: ${theme.colors.gray17};
  border-radius: 50%;
  border: solid 2px ${theme.colors.gray17};
  box-sizing: border-box;
  display: inline-block;
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
  font-weight: 600;
  height: ${theme.unit * 8}px;
  line-height: ${theme.unit * 7.5}px;
  text-align: center;
  text-transform: uppercase;
  width: ${theme.unit * 8}px;

  & + span {
    margin-left: ${theme.unit * 2}px;
  }

  ${({ medium }) => medium && `
    height: ${theme.unit * 6}px;
    line-height: ${theme.unit * 5.5}px;
    width: ${theme.unit * 6}px;
  `}

  ${({ small }) => small && `
    height: ${theme.unit * 4.125}px;
    line-height: ${theme.unit * 3.875}px;
    width: ${theme.unit * 4.125}px;
    margin: ${theme.unit * 0.5}px ${theme.unit}px ${theme.unit * 0.5}px 0;

    & + span {
      margin-left: 0;
    }
  `}
`.withComponent(({
  medium, small, // strip
  name, children,
  ...props
}) => {
  let initials;
  if (children) {
    if (typeof children === 'string') {
      initials = children.slice(0, 2);
    }
  }
  if (name) {
    initials = name.slice(0, 2);
  }
  return (
    <i {...props}>{initials ? <small>{initials}</small> : children}</i>
  );
}));

export default SpaceIcon;



// WEBPACK FOOTER //
// ./src/components/icons/SpaceIcon.js